import { useRef, useState, useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import './FormUnsubscribe.scss';
import { languageElements } from './FormUnsubscribe-languageElements';
import LanguageElementsHandler from '../../../repository/languageElementsHandler/LanguageElementsHandler';
import SelFP from '../../../repository/SelForm/SelFP';
import FiveSecondsAlert from '../../alerts/fiveSecondsAlert/FiveSecondsAlert';
import BlockScreen from '../../alerts/blockScreen/BlockScreen';
import useMain from '../../../common/MainContext';

export default function FormUnsubscribe(props) {
    const { language } = useMain();
    const languageElementsHandler = new LanguageElementsHandler(languageElements, language);

    const fields = [];
    const fp = new SelFP({ language, languageElements, fields, });

    const [dataState, setDataState] = useState('LOADING');
    const [fpStates, setFpStates] = useState(fp.initStates());
    const [stateOfBlockScreen, setStateOfBlockScreen] = useState({
        show: false,
    });

    const [stateOfFiveSecondsAlert, setStateOfFiveSecondsAlert] = useState({
        show: false,
        message: {
            title: '',
            body: '',
        }
    });

    useEffect(() => {
        if (!props.regLoginData) {
            return;
        }

        axios.get(`${process.env.REACT_APP_API_BASE_URL}/registration`, {
            headers: {
                'x-token': props.regLoginData.getToken(),
            }
        }).then(result => {
            fp.setValues(fpStates, setFpStates, result.data);
            setDataState('LOADED');
        }).catch(error => {
            console.error(error);
        });
    }, [props.regLoginData])

    async function unsubscribe() {
        if (!fp.isGroupValid(fpStates, setFpStates)) {
            return;
        }

        setStateOfBlockScreen({ show: true })

        axios.delete(
            `${process.env.REACT_APP_API_BASE_URL}/registration`,
            {
                headers: {
                    "x-token": props.regLoginData.getToken(),
                },
            }
        ).then(result => {
            setStateOfFiveSecondsAlert({
                show: true,
                variant: 'primary',
                interval: 1500,
                className: 'text-center',
                message: {
                    title: languageElementsHandler.get('MESSAGE_DATA_SUCCESSFULLY_UNSUBSCRIBED-title')
                },
                callback: () => props.callback({ result: 'UNSUBSCRIBED' }),
            });

            return;
        }).catch(err => {
            switch (err.response?.data?.message || '') {
                default:
                    console.error(err);
                    break;
            }
        }).finally(() => {
            setStateOfBlockScreen({ show: false })
        });
    }

    return (
        <div className='form-unsubscribe'>
            <BlockScreen
                show={stateOfBlockScreen.show}
                variant={stateOfBlockScreen.variant}
                className={stateOfBlockScreen.className}
            />
            <FiveSecondsAlert
                show={stateOfFiveSecondsAlert.show}
                message={stateOfFiveSecondsAlert.message}
                variant={stateOfFiveSecondsAlert.variant}
                interval={stateOfFiveSecondsAlert.interval}
                className={stateOfFiveSecondsAlert.className}
                callback={() => {
                    setStateOfFiveSecondsAlert({ show: false });
                    if (stateOfFiveSecondsAlert.callback) {
                        stateOfFiveSecondsAlert.callback();
                    }
                }}
            />

            <h2>{languageElementsHandler.get('form-title')}</h2>

            {
                (dataState === 'LOADING') &&
                <div className='spinner-centered'>
                    <Spinner variant='danger' />
                </div>
            }

            {
                (dataState === 'LOADED') &&
                <form
                    noValidate={true}
                    className={`needs-validation ${fpStates.formWasValidated ? 'was-validated' : ''}`}
                >
                    <div className='form-unsubscribe-text-area'>
                        <h5>{languageElementsHandler.get('form-text')}</h5>
                    </div>

                    <div className="btn-area">
                        <Button onClick={unsubscribe}>
                            {languageElementsHandler.get(`btn-submit`)}
                        </Button>
                    </div>
                </form>
            }
        </div>
    )
}
